import React from 'react'
import { useParams } from 'react-router-dom'
import { Heading2 } from '@gousto-internal/citrus-react'
import { Alert, LayoutContentWrapper, LayoutPageWrapper } from 'goustouicomponents/dist'
import { HeroWithBreadcrumbs } from '../../components/HeroWithBreadcrumbs'
import { useFetchCategories } from '../../hooks/useFetchCategories'
import { useFetchSections } from '../../hooks/useFetchSections'
import { NavigationCategories } from '../../components/NavigationCategories'
import { TwoColumns, MainColumn, SecondaryColumn } from '../../layouts/TwoColumns'
import { SectionContentPreview } from '../../components/SectionContentPreview'
import { ContentLoader } from '../../components/ContentLoader'

type IdInParams = { id: string }

const Categories = () => {
  const { id: paramId }: IdInParams = useParams()

  const {
    categoriesError,
    isCategoriesFetching,
    categories,
  } = useFetchCategories()

  const {
    sectionsError,
    isSectionsFetching,
    sections,
    sectionsResponse,
  } = useFetchSections(paramId)

  const sectionCategories = sectionsResponse?.categories
  const sectionCategory = sectionCategories && sectionCategories[0]

  if (
    categoriesError
    || sectionsError
    || (!isCategoriesFetching && !categories)
    || (!isSectionsFetching && !sections)
    || (!isSectionsFetching && !sectionCategories)
  ) {
    return (
      <LayoutPageWrapper>
        <LayoutContentWrapper>
          <Alert type="danger">
            <Heading2 size={4}>Something went wrong!</Heading2>
            <p>There is an issue fetching the topics.</p>
          </Alert>
        </LayoutContentWrapper>
      </LayoutPageWrapper>
    )
  }

  return (
    <>
      <HeroWithBreadcrumbs
        categories={categories}
        currentCategoryId={paramId}
      />
      <TwoColumns>
        <SecondaryColumn>
          {categories ? (
            <NavigationCategories
              categories={categories}
              currentTopicId={paramId}
              sections={sections || []}
            />
          ) : (
            <ContentLoader />
          )}
        </SecondaryColumn>
        <MainColumn>
          {categories && sectionCategory ? (
            <SectionContentPreview
              sections={sections || []}
              category={sectionCategory}
            />
          ) : (
            <ContentLoader />
          )}
        </MainColumn>
      </TwoColumns>
    </>
  )
}

export { Categories }
